import { render, staticRenderFns } from "./documentTemplateEdit.vue?vue&type=template&id=0698ee03"
import script from "./documentTemplateEdit.vue?vue&type=script&lang=js"
export * from "./documentTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports